export default __webpack_public_path__ + "static/1-be19e6cf9e72d34c26dacc10bda20c28.jpeg";